var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNativeIntegrationsinline = function SvgNativeIntegrationsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.097.951C7.504.35 8.496.35 8.903.951l6.448 9.53a.8.8 0 0 1 .024.895c-.166.273-.493.488-.926.488H1.55c-.433 0-.76-.215-.926-.488a.8.8 0 0 1 .023-.895z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.462 7.329c.244-.379.832-.379 1.075 0l4.69 7.287c.232.36-.015.883-.537.883H3.31c-.523 0-.769-.523-.537-.883z"
  })));
};
export default SvgNativeIntegrationsinline;